import React from 'react';

const ScoreDisplay = ({ score, isLiveView }) => {
  return (
    <div className={`flex justify-center items-center bg-white p-[1vh] w-[20vh] h-[18vh] `}>
      <span className={`${isLiveView ? 'text-[23vh] font-chivo' : 'text-[20vh]'} font-bold leading-none`}>
        {score}
      </span>
    </div>
  );
};

export default ScoreDisplay;